import React from 'react';

const SelectField = ({ label, name, options, register, explanation, rules, error, valueField, textField }) => (
    <div className='mb-3 flex flex-col w-full'>
        <label className='text-brandDarkBlue text-sm font-bold pr-6 mb-1'>{label} {rules && <span className='text-red'>*</span>}</label>
        <select 
            {...register(name, rules)}
            className={`bg-white h-12 py-1 px-4 w-full text-black ${error ? 'border border-red focus:outline-red' : ''}`}>
            <option value="">Please select</option>
            {options.map((option, index) => {
                const v = valueField ? option[valueField] : option;
                const t = textField ? option[textField] : option;
                return (
                    <option key={index} value={v}>{t}</option>
                )
            })}
      </select>
      {explanation && (
            <span className='text-brandDarkBlue text-xs text-gray-500 my-1'>{explanation}</span>
        )}
      {error && <span className="text-red text-xs">{error}</span>}
    </div>
);

export default SelectField;